define('frontend-common-components/objectStorageConfig/nls/root/objectStorageConfig',{
    'storage': {
        'signiantFlightRole': 'SigniantFlightRole',
        'notValidArn': 'Not a valid Role ARN',
        'emptyArn': 'Role ARN required',
        'services': {
            'AWS': 'Amazon S3',
            'AZURE': 'Microsoft Azure'
        },
        'azureServiceName': 'Microsoft Azure',
        'addPanel': {
            'error': {
                'bucketAccess.delete.error': 'Unable to use the bucket without delete privileges',
                'bucketAccess.list.error': 'Unable to use the bucket without list privileges',
                'bucketAccess.does.not.exist.error': 'The bucket no longer exists',
                'bucketAccess.upload.error': 'Unable to use the bucket without upload privileges',
                'bucketAccess.download.error': 'Unable to use the bucket without download privileges',
                'bucketAccess.could.not.assume.aws.role.error': 'Could not assume the role',
                'bucketAccess.error': 'Could not assume the role'
            },
            'roleArnPlaceholder': 'Enter a valid Role ARN',
            'bucketPlaceholder': '(optional)',
            'accountId': 'Signiant\'s Account ID',
            'externalId': 'External ID',
            'roleArn': 'Role ARN',
            'bucket': 'Bucket:',
            'help': 'How to create a Role ARN.',
            'addButton': 'Add cloud storage',
            'instruction': 'Allow access by providing an AWS Role ARN.',
            'emptyBucketList': 'No buckets available for the Role ARN',
            'bucketSpecifiedInConfiguration': 'Bucket specified in client',
            'selectType': 'Select type:',
            'notValidCredentials': 'Credentials not valid',
            'filePrefixPlaceholder': 'Directory name (Optional)',
            'encryption': 'Encryption',
            'enableServerSideEncryption': 'Encrypt contents at rest',
            'aws': {
                'bucketConfigurationLabel': 'Bucket',
                'bucketSpecifiedInConfiguration': 'Bucket specified in client',
                'noBucketsError': 'No buckets found for the RoleARN, please create a bucket and try again'
            },
            'azure': {
                'bucketConfigurationLabel': 'Container',
                'bucketSpecifiedInConfiguration': 'Container specified in client',
                'noContainersError': 'No containers found for the account, please create a container and try again',
                'instructions': 'Allow access to Azure',
                'account': 'Account',
                'key': 'Key',
                'storageAccountPlaceholder': 'Enter the Azure storage account name',
                'containerSpecifiedInConfiguration': 'Container specified in configuration',
                'keyPlaceholder': 'Enter the primary or secondary access key',
                'container': 'Container'
            },
            'notValidFilePrefix': 'Only alphanumeric characters and !_.*’()- can be used',
            'notValidStoragePrefixLength': 'Directory name should be less than 100 characters',
            'specifyDirectoryLink': 'Specify a directory',
            'slash': '/',
            'specifyBlobLink': 'Specify a directory'
        }
    }
});
